import * as Routes from '@/router/routes';

export const AFTERCARE_OPTIONS_WITH_DROP_IN = (vm) => [
    {
        img: require('../../../../assets/img/secondary-menu-expand-plus.svg'),
        name: 'Add to Rosters',
        action: vm.addChildToRosters,
        permission: {
            name: 'rosters.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/secondary-menu-expand-plus.svg'),
        name: 'Add to Waitlist',
        action: vm.addChildToWaitlist,
        permission: {
            name: 'rosters.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/secondary-menu-expand-plus.svg'),
        name: 'Add to Drop-in',
        action: vm.addChildToDropIn,
        permission: {
            name: 'dropin.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/edit.svg'),
        name: 'Edit',
        action: vm.openAftercareFormForEdit,
        permission: {
            name: 'sessions.aftercare',
            rules: 'edit'
        }
    },
    {
        img: require('../../../../assets/img/copy.svg'),
        name: 'Duplicate',
        action: vm.openAftercareFormForDuplicate,
        permission: {
            name: 'sessions.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/link.svg'),
        name: 'Copy link',
        action: vm.copyLink,
        permission: {
            name: 'sessions.aftercare',
            rules: 'copy'
        }
    },
    {
        img: require('../../../../assets/img/delete.svg'),
        name: 'Delete',
        action: vm.confirmDeleteAftercare,
        permission: {
            name: 'sessions.aftercare',
            rules: 'remove'
        }
    }
];

export const AFTERCARE_OPTIONS_WITHOUT_DROP_IN = (vm) => [
    {
        img: require('../../../../assets/img/secondary-menu-expand-plus.svg'),
        name: 'Add to Rosters',
        action: vm.addChildToRosters,
        permission: {
            name: 'rosters.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/secondary-menu-expand-plus.svg'),
        name: 'Add to Waitlist',
        action: vm.addChildToWaitlist,
        permission: {
            name: 'rosters.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/edit.svg'),
        name: 'Edit',
        action: vm.openAftercareFormForEdit,
        permission: {
            name: 'sessions.aftercare',
            rules: 'edit'
        }
    },
    {
        img: require('../../../../assets/img/copy.svg'),
        name: 'Duplicate',
        action: vm.openAftercareFormForDuplicate,
        permission: {
            name: 'sessions.aftercare',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/link.svg'),
        name: 'Copy link',
        action: vm.copyLink,
        permission: {
            name: 'sessions.aftercare',
            rules: 'copy'
        }
    },
    {
        img: require('../../../../assets/img/delete.svg'),
        name: 'Delete',
        action: vm.confirmDeleteAftercare,
        permission: {
            name: 'sessions.aftercare',
            rules: 'remove'
        }
    }
];


// WEBPACK FOOTER //
// ./src/components/main/pages/aftercare/aftercare.options.config.js